/**
 * Resource maturity levels.
 *
 */
export enum ResourceMaturity {
  Draft = "DRAFT",
  InDevelopment = "IN_DEVELOPMENT",
  ReadyForReview = "READY_FOR_REVIEW",
  ArtworkPending = "ARTWORK_PENDING",
  ArtworkInProgress = "ARTWORK_IN_PROGRESS",
  ArtworkFeedback = "ARTWORK_FEEDBACK",
  ArtworkComplete = "ARTWORK_COMPLETE",
  Feedback = "FEEDBACK",
  DevelopmentComplete = "DEVELOPMENT_COMPLETE",
  QualityTestingPending = "QUALITY_TESTING_PENDING",
  QualityTestingInProgress = "QUALITY_TESTING_IN_PROGRESS",
  QualityTestingFailed = "QUALITY_TESTING_FAILED",
  QualityTestingComplete = "QUALITY_TESTING_COMPLETE",
  QualityAssurance = "QUALITY_ASSURANCE",
  BlockedPreview = "BLOCKED_PREVIEW",
  FinalEdits = "FINAL_EDITS",
  FinalReview = "FINAL_REVIEW",
  Piloting = "PILOTING",
  PilotTesting = "PILOT_TESTING",
  PreOperational = "PRE_OPERATIONAL",
  FieldTesting = "FIELD_TESTING",
  Operational = "OPERATIONAL",
  Retired = "RETIRED",
  Rejected = "REJECTED",
}
